/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Environment, Environment$inboundSchema } from "./environment.js";

/**
 * Result type for listing environments
 */
export type ListEnvironmentsResult = {
  environments: Array<Environment>;
};

/** @internal */
export const ListEnvironmentsResult$inboundSchema: z.ZodMiniType<
  ListEnvironmentsResult,
  unknown
> = z.object({
  environments: z.array(Environment$inboundSchema),
});

export function listEnvironmentsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListEnvironmentsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEnvironmentsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEnvironmentsResult' from JSON`,
  );
}
